__webpack_require__.p = "/assets/turbo/edef3470/quellede/_next/";